import React from 'react';
import MLButton from '../../../../../components/MLButton/MLButton';
import MLIcon from '../../../../../components/MLIcon/MLIcon';
import s from './GRSAIEnableBanner.module.css';
import PropTypes from 'prop-types';

const GRSAIEnableBanner = ({ onShowModal }) => {
  return (
    <div className={s.banner} aria-label="Summaries Opt-In">
      <div className={s.content}>
        <div className={s.textWrapper}>
          <MLIcon type="sparkle" className={s.sparkleIcon} />
          <span className={s.text}>
            Try it out! Achieve can now summarize student responses to select
            survey questions.
          </span>
        </div>
        <MLButton
          btnType="primary"
          className={s.button}
          testId="Insights_grs_summaries_enable_btn"
          btnText="Turn on Summaries"
          onClick={onShowModal}
        />
      </div>
    </div>
  );
};

GRSAIEnableBanner.propTypes = {
  onShowModal: PropTypes.func.isRequired,
};

export default GRSAIEnableBanner;
